import { DEFAULT_LOCATIONS, ROPESGRAY, DROPDOWN } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token 8a2f551de90eb8c8682d0a4990affca777812325',
  staging: 'Token 56181f8e1dd7d5d56eba3be1a91bfbcaff4a3f24',
  prod: 'Token 6eb1a0d136c968adeecc82228637feab53b1fd07',
};

const token = selectToken(apiTokens);

const ropesGrayConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'ropesgray',

  API_TOKEN: token,
  EMBOLD_CLIENT: ROPESGRAY,

  // login
  SHOW_REGION_SELECTOR: true,
  NETWORKS: {},

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Boston },
  LOGIN_NETWORK_NAME: 'ropesGrayUserId',

  // content
  DISPLAY_NAME: 'Ropes & Gray',
  FORM_VARIANT: DROPDOWN,
  NO_WELCOME_LINK: false,
};

export default ropesGrayConfig;
